<template>
    <div>
        <div>
            <!-- Added gx-2 to reduce horizontal gutter between columns -->
            <div class="row gx-2 mb-3">
                <div class="col-lg-5 col-xl-4 col-12 position-relative benchmark-title-image-wrapper">
                    <!-- Added img-fluid so the image scales responsively within its column -->
                    <!-- <img class="benchmark-title-image img-fluid w-100 md-md-0 mb-3" src="/img/images/benchmark-image.jpg"> -->
                </div>

                <div class="col-lg-7 col-xl-8 col-12 px-0 px-lg-2 pt-3 pt-lg-0">
                    <div class="card h-100">
                        <div class="card-body m-0 p-0">
                            <div class="row mb-3">
                            </div>
                            
                            <div class="row mx-2">
                                <div class="col">
                                    <div class="top-card">
                                        <div class="d-flex cobrand-logo-container mb-4">
                                            <a class="navbar-brand" href="/">
                                                <img src="/img/logo_png/avid_logo_red.png" alt="Avid" class="navbar-brand-logo px-2" style="height: 40px;">
                                            </a>
                                            <div class="mx-0 d-flex justify-content-center align-items-center"><span class="h1 mb-0 text-primary fw-normal">+</span></div>
                                            <a class="navbar-brand" href="https://www.wiland.com" target="_blank">
                                                <img src="/img/logo_png/wiland_logo.svg" alt="Wiland" class="navbar-brand-logo px-2" style="height: 35px;">
                                            </a>
                                        </div>
                                        <p class="mb-0 ms-2">A current view of giving.</p>
                                        <h2 class="mb-3 ms-2">Built from 1,000 nonprofits.</h2>
                                        <p class="mb-3 ms-2">
                                            Updated monthly with data from more than 1,000 nonprofits, this benchmark shows how giving is changing in real time. It covers the essential KPIs along with insights you will not find anywhere else, like upgrade rates, recurring growth patterns, and multichannel behavior.
                                        </p>
                                        <p class="mb-3 ms-2">
                                            Custom built with Wiland, it helps you see where you stand and where the sector is moving.
                                        </p>
                                    </div>
                                    <button class="btn btn-secondary mb-3 ms-2" @click="openModal">
                                        <img class="icon me-1" src="/img/icons/avid-icons/deep-dive.svg" alt=""></img>
                                        Learn more about Benchmarks
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mb-3" v-if="page == null">
                <div class="col-12">
                    <div class="navbar navbar-expand bg-secondary rounded p-3">
                        <h4 class="mb-0 text-primary"><span class="d-inline-block spinner-border spinner-border-sm me-2" role="status"></span>
                        Your benchmark report is loading...</h4>
                    </div>
                </div>
            </div>

            <div class="row mx-0 mb-4" id="top-of-page" v-if="page != null">
                <div class="col-12 px-0">
                    <h2 class="my-4">Benchmarks Library</h2>
                    <div class="row g-3 mb-4">
                        <div v-for="(section, index) in orderedSections" 
                                :key="section.id" 
                                v-show="index != 0"
                                class="col-12 col-md-6 col-lg-4 col-xxl-3">
                            <div class="insights-report-card h-100" :class="getCardColorClass(section, index)">
                                <div class="d-flex align-items-center mb-3">
                                    <div class="insights-report-card-icon me-3">
                                        <img :src="getSectionIcon(section)" :alt="section.title" class="icon">
                                    </div>
                                    <h3 class="insights-report-card-title">{{ section.title }}</h3>                             
                                </div>
                                <p class="insights-report-card-description mt-2">{{ section.description || 'View benchmark data and insights.' }}</p>
                                <div class="mt-4">
                                    <button type="button" class="btn view-btn btn-sm px-4" @click="$emit('goToSection', section.id)">
                                        View Benchmark
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3 mb-3">
                        <div class="col-12 text-center">
                            <button type="button" class="btn btn-primary px-4" @click="$emit('goToViewAll')">
                                View All Sections Combined
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- Learn More About Benchmarks Modal -->
        <div class="modal fade" id="learn-more-benchmarks-modal" tabindex="-1" aria-labelledby="learn-more-benchmarks-modal-label" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header border-bottom-0 pb-0">
                        <div class="text-center w-100">
                            <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" data-bs-toggle="tooltip" title="Close">
                                <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                            </button>
                            <h3 class="mt-2">The Only Real-Time Fundraising Benchmark</h3>
                        </div>
                    </div>
                    <div class="modal-body">
                        <p class="lead mb-4">
                            Built From 1,000+ Nonprofits—Updated Monthly and Powered by Avid + Wiland
                        </p>
                        
                        <p class="mb-3">
                            Updated monthly with data from more than 1,000 nonprofits, this living benchmark gives you a current, accurate view of how giving is shifting across the sector. You'll see what's steady, what's slipping, and where your own results stand in comparison—clarity fundraisers rarely get in real time.
                        </p>
                        
                        <p class="mb-3">
                            It's built to take guesswork off your plate and help you act with confidence. Alongside essential KPIs like donor counts, revenue trends, retention, and channel-level performance, you'll also get deeper insights you won't find anywhere else, including:
                        </p>
                        
                        <ul class="mb-3">
                            <li>Upgrade rates showing how donors move into mid- and major-giving</li>
                            <li>Recurring-giving segmentation and growth patterns</li>
                            <li>Multichannel giving behavior</li>
                        </ul>
                        
                        <p class="mb-0">
                            Designed by Avid and Wiland for fundraising leaders who need fast, actionable intelligence, this benchmark helps you see where you stand today, anticipate what's coming next, and focus on the work that truly moves your mission forward. With interactive dashboards, continuous updates, and unprecedented visibility into donor behavior, it's the most actionable benchmarking resource available to nonprofits.
                        </p>
                    </div>
                </div>
            </div>
        </div>            
    </div>
</template>

<script>
    import { defineComponent, ref, nextTick } from 'vue';
    import { Tooltip } from 'bootstrap';
    import permissionsMixin from '../../mixins/permissions';
    import BenchmarkViewWilandDemoCta from './BenchmarkViewWilandDemoCta.vue';

    export default defineComponent({
        components: { BenchmarkViewWilandDemoCta },
        props: {
            user: {
                type: [Object, null],
            },
            client: {
                type: [Object, null],
            },
            connections: {
                type: [Array, null],
            },
            section_id: {
                type: [Number, null],
            },
            dashboard_pages: {
                type: Array,
                default: () => []
            },
            report_groups: {
                type: Array,
                default: () => []
            }
        },
        mixins: [permissionsMixin],
        setup() {
            const benchmarkPage = ref(null);
            const tooltips = ref([]);

            return {
                benchmarkPage,
                tooltips
            };
        },
        data() {
            return {
                page: null,
                local_page: {},
                benchmark_page: null,
                wiland_page: null,
                reportGroups: [],
                active_tab_index: 1,
                selected_ticket_type: ''
            };
        },
        beforeMount() {
            if (this.dashboard_pages && this.dashboard_pages.length >= 1) {
                this.page = {};
                const combinedSections = [
                    { id: 0, title: '', is_section_tab_active: false }
                ];
                const wilandPage = this.dashboard_pages[0];
                if (wilandPage && wilandPage.sections && wilandPage.sections.length > 0) {
                    wilandPage.sections.forEach(section => {
                        combinedSections.push({
                            ...section,
                            is_section_tab_active: false
                        });
                    });
                }
                if (this.dashboard_pages.length >= 2) {
                    const benchmarkPage = this.dashboard_pages[1];
                    if (benchmarkPage && benchmarkPage.sections && benchmarkPage.sections.length > 0) {
                        benchmarkPage.sections.forEach(section => {
                            combinedSections.push({
                                ...section,
                                is_section_tab_active: false
                            });
                        });
                    }
                }
                this.local_page = { sections: combinedSections };
                if (this.report_groups && this.report_groups.length) {
                    this.reportGroups = this.report_groups;
                }
            }

            if (!this.page) {
                this.loadBenchmark();
            }
        },
        mounted() {
            // Initialize tooltips after component is mounted
            nextTick(() => {
                this.initializeTooltips();
            });
        },
        computed: {
            sections() {
                return this.local_page.sections || [];
            },
            orderedSections() {
                const raw = this.sections;
                if (!raw.length) return raw;
                const [placeholder, ...rest] = raw;
                const groups = this.reportGroups || [];
                const orderByGroup = (a, b) => {
                    const idxA = groups.findIndex(g => g.group_name && (a.title || a.group_name || '').toLowerCase().includes(g.group_name.toLowerCase().trim()));
                    const idxB = groups.findIndex(g => g.group_name && (b.title || b.group_name || '').toLowerCase().includes(g.group_name.toLowerCase().trim()));
                    const orderA = idxA === -1 ? 999 : (groups[idxA]?.order ?? idxA);
                    const orderB = idxB === -1 ? 999 : (groups[idxB]?.order ?? idxB);
                    return orderA - orderB;
                };
                return [placeholder, ...rest.sort(orderByGroup)];
            }
        },
        watch: {
            section_id: {
                handler(newVal) {
                    if (this.section_id > 0) {
                        var index = this.local_page.sections.findIndex(section => section.id == this.section_id);
                        if (index >= 0) {
                            this.setActiveTab(index);
                        } else {
                            this.setActiveTab(0);
                        }
                    }
                }
            },
            page: {
                handler(newValue) {
                    if (newValue) {
                        nextTick(() => {
                            this.initializeTooltips();
                        });
                    }
                }
            }
        },
        methods: {
            loadBenchmark() {
                var self = this;
                let benchmarkUrl;
                let wilandBenchmarkUrl;
                
                if(this.client == null) {
                    benchmarkUrl = '/api/benchmarks/demo/10294/charts';
                    wilandBenchmarkUrl = '/api/wiland_benchmarks/demo/10123/charts';
                } else {
                    benchmarkUrl = '/api/benchmarks/' + this.client.url + "/10294/charts";
                    wilandBenchmarkUrl = '/api/wiland_benchmarks/' + this.client.url + "/10123/charts";
                }
                
                if (this.section_id > 0) {
                    benchmarkUrl += '/' + this.section_id;
                    wilandBenchmarkUrl += '/' + this.section_id;
                }

                if (!(this.report_groups && this.report_groups.length)) {
                    window.axios.get('/api/insights/report_groups')
                        .then(r => { self.reportGroups = r.data.data || []; })
                        .catch(() => {});
                }

                Promise.all([
                    window.axios.get(benchmarkUrl),
                    window.axios.get(wilandBenchmarkUrl)
                ])
                    .then(([benchmarkResponse, wilandResponse]) => {
                        const benchmarkPage = benchmarkResponse.data.page;
                        const wilandPage = wilandResponse.data.page;
                        
                        // Store both pages separately for filter requests
                        self.benchmark_page = JSON.parse(JSON.stringify(benchmarkPage));
                        self.wiland_page = JSON.parse(JSON.stringify(wilandPage));
                        
                        // Set page data (keep existing sections from beforeMount)
                        if (!self.page) {
                            self.page = {};
                        }
                        if (!self.local_page || !self.local_page.sections) {
                            self.local_page = { sections: [] };
                        }
                        
                        // Always use benchmark dimensions for filters (wiland doesn't have filters)
                        if (benchmarkPage.dimensions && benchmarkPage.dimensions.length > 0) {
                            self.local_page.dimensions = benchmarkPage.dimensions;
                            self.page.dimensions = benchmarkPage.dimensions;
                        }
                        
                        self.loadSectionTab();
                        
                        if (self.section_id > 0) {
                            var index = self.local_page.sections.findIndex(section => section.id == self.section_id);
                            if (index >= 0) {
                                self.setActiveTab(index);
                            } else {
                                self.setActiveTab(1);
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error loading benchmark:', error);
                    });
            },
            loadSectionTab() {
                for(var i = 0; i < this.local_page.sections.length; i++) {
                    if(i == 1) {
                        this.local_page.sections[i].is_section_tab_active = true;
                    } else {
                        this.local_page.sections[i].is_section_tab_active = false;
                    }
                }
            },
            initializeTooltips() {
                // Destroy existing tooltips first
                this.tooltips.forEach(tooltip => {
                    tooltip.dispose();
                });
                this.tooltips = [];

                // Initialize new tooltips
                if (this.benchmarkPage) {
                    const tooltipElements = this.benchmarkPage.querySelectorAll('[data-bs-toggle="tooltip"]');
                    tooltipElements.forEach(element => {
                        const tooltip = new Tooltip(element);
                        this.tooltips.push(tooltip);
                    });
                }
            },
            setActiveTab(index) {
                if(index == 0) return;

                // Update tab states
                for(var i = 0; i < this.local_page.sections.length; i++) {
                    if(i == index) {
                        this.local_page.sections[i].is_section_tab_active = true;
                    } else {
                        this.local_page.sections[i].is_section_tab_active = false;
                    }
                }
                this.active_tab_index = index;

                // Use nextTick to ensure DOM is updated before reinitializing tooltips
                nextTick(() => {
                    this.initializeTooltips();
                });
            },
            getGroupForSection(section) {
                const sectionName = (section.title || section.group_name || '').trim();
                if (!sectionName) return null;
                const sectionLower = sectionName.toLowerCase();
                // report_groups has shorter names; match when section title contains group_name.
                // Sort by group_name length descending so "Giving Levels" matches before "Giving".
                const sorted = [...(this.reportGroups || [])]
                    .filter(g => g.group_name)
                    .sort((a, b) => (b.group_name.length - a.group_name.length));
                return sorted.find(g => sectionLower.includes(g.group_name.toLowerCase().trim())) || null;
            },
            getSectionIcon(section) {
                const group = this.getGroupForSection(section);
                if (group && group.icon) {
                    const iconPath = group.icon.startsWith('/') ? group.icon : '/img/icons/avid-icons/' + group.icon;
                    return iconPath;
                }
                return '/img/icons/avid-icons/chart-infographic.svg';
            },
            getCardColorClass(section, index) {
                const group = this.getGroupForSection(section);
                if (!group || group.color === '' || group.color === null) {
                    return 'color-purple';
                }
                const normalizedColor = group.color.toLowerCase().trim();
                return 'color-' + normalizedColor;
            },
            openSupportModal() {
                this.selected_ticket_type = 'FEATURE_REQUEST';
            },
            openModal() {
                // Open Learn More About Benchmarks modal using Bootstrap
                const modalElement = document.getElementById('learn-more-benchmarks-modal');
                if (modalElement) {
                    const modal = new window.bootstrap.Modal(modalElement);
                    modal.show();
                    
                    // Initialize tooltips after modal is shown
                    modalElement.addEventListener('shown.bs.modal', () => {
                        this.$nextTick(() => {
                            this.initializeTooltips();
                        });
                    });
                }
            }
        },
        beforeUnmount() {
            // Clean up tooltips
            this.tooltips.forEach(tooltip => {
                tooltip.dispose();
            });
        }
    });
</script>